export var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType["AgendaPublished"] = "agenda-published";
    EmailTemplateType["AgendaUpdated"] = "agenda-updated";
    EmailTemplateType["AppointmentConfirmedMember"] = "appointment-confirmed-member";
    EmailTemplateType["AppointmentConfirmedStaff"] = "appointment-confirmed-staff";
    EmailTemplateType["GovernmentSubscribeInvitation"] = "government-subscribe-invitation";
    EmailTemplateType["LegislativeItemComment"] = "legislative-item-comment";
    EmailTemplateType["LegislativeItemWorkflowStepAssigned"] = "legislative-item-workflow-step-assigned";
    EmailTemplateType["LegislativeItemWorkflowStepAssignedAsBackup"] = "legislative-item-workflow-step-assigned-as-backup";
    EmailTemplateType["LegislativeItemWorkflowBackupAction"] = "legislative-item-workflow-backup-action";
    EmailTemplateType["LegislativeItemWorkflowRecalled"] = "legislative-item-workflow-recalled";
    EmailTemplateType["LegislativeItemFollowedUpdated"] = "legislative-item-followed-updated";
    EmailTemplateType["MeetingCancelled"] = "meeting-cancelled";
    EmailTemplateType["MeetingCreated"] = "meeting-created";
    EmailTemplateType["MeetingRescheduled"] = "meeting-rescheduled";
    EmailTemplateType["MeetingRoleAssigned"] = "meeting-role-assigned";
    EmailTemplateType["ScheduledApplicationDeadlineReminder"] = "scheduled-application-deadline-reminder";
    EmailTemplateType["ScheduledIncompleteApplicationReminder"] = "scheduled-incomplete-application-reminder";
    EmailTemplateType["ScheduledLegislativeItemWorkflowStepDue"] = "scheduled-legislative-item-workflow-step-due";
    EmailTemplateType["ScheduledLegislativeItemWorkflowStepOverdue"] = "scheduled-legislative-item-workflow-step-overdue";
    EmailTemplateType["ScheduledMeetingBodySeatVacated"] = "scheduled-meeting-body-seat-vacated";
    EmailTemplateType["ScheduledMeetingReminder"] = "scheduled-meeting-reminder";
    EmailTemplateType["ScheduledTermExpired"] = "scheduled-term-expired";
    EmailTemplateType["ScheduledTermExpiringSoon"] = "scheduled-term-expiring-soon";
    EmailTemplateType["ScheduledTermExpiringSoonMember"] = "scheduled-term-expiring-soon-member";
    EmailTemplateType["SeatApplicationReceived"] = "seat-application-received";
    EmailTemplateType["SeatApplicationReviewRequested"] = "seat-application-review-requested";
    EmailTemplateType["SeatApplicationStatusChanged"] = "seat-application-status-changed";
    EmailTemplateType["SeatApplicationNominated"] = "seat-application-nominated";
    EmailTemplateType["SeatApplicationRejected"] = "seat-application-rejected";
    EmailTemplateType["SeatApplicationSubmitted"] = "seat-application-submitted";
    EmailTemplateType["SeatApplicationUnsubmitted"] = "seat-application-unsubmitted";
    EmailTemplateType["SeatVacancyCreated"] = "seat-vacancy-created";
    EmailTemplateType["SignatureRequestCancelled"] = "signature-request-cancelled";
    EmailTemplateType["SignatureRequestCompleted"] = "signature-request-completed";
    EmailTemplateType["SignatureRequestDeclined"] = "signature-request-declined";
    EmailTemplateType["SignatureRequested"] = "signature-requested";
})(EmailTemplateType || (EmailTemplateType = {}));
